var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTube = function SvgTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 78,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M118.27 22.772v54.61h-12.977v-38.61l1.75-.656 2.134-1.16 2.03-1.317 2.027-1.83 1.729-2.065 1.978-2.915.932-2.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tube_svg__a)",
    d: "M118.27 22.772v54.61h-12.977v-38.61l1.75-.656 2.134-1.16 2.03-1.317 2.027-1.83 1.729-2.065 1.978-2.915.932-2.795z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tube_svg__b)",
    d: "M98.887 13.56a5.562 5.562 0 1 0 0 11.123 5.562 5.562 0 0 0 0-11.124m-104.922 0h87.232a18.5 18.5 0 0 0-.849 5.56c0 10.24 8.3 18.54 18.54 18.54 10.238 0 18.538-8.3 18.538-18.54 0-10.238-8.3-18.538-18.539-18.538H-6.035z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tube_svg__a",
    x1: 114.448,
    x2: 105.678,
    y1: 63.816,
    y2: 26.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tube_svg__b",
    x1: 24.635,
    x2: 111.626,
    y1: 26.738,
    y2: 10.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E2EA",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })))));
};
export default SvgTube;